import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ReportStatus } from '../../types';
import './StatusLegendTooltip.css';

const STATUS_LIFECYCLE: ReportStatus[] = [
  ReportStatus.NEW,
  ReportStatus.READY,
  ReportStatus.IN_PROGRESS,
  ReportStatus.SIGNED,
  ReportStatus.CLOSED
];

export const StatusLegendTooltip: React.FC = () => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);
  const tooltipRef = useRef<HTMLDivElement>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        tooltipRef.current &&
        !tooltipRef.current.contains(event.target as Node) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target as Node)
      ) {
        setIsVisible(false);
      }
    };

    if (isVisible) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isVisible]);

  return (
    <div className="status-flow-tooltip-container">
      <button
        ref={buttonRef}
        type="button"
        className="status-flow-trigger"
        onClick={() => setIsVisible(!isVisible)}
        aria-label={t('statusLegend.helpLabel')}
        aria-expanded={isVisible}
      >
        <span className="material-icons">help_outline</span>
      </button>

      {isVisible && (
        <div
          ref={tooltipRef}
          className="status-flow-tooltip status-legend-tooltip"
          role="tooltip"
        >
          <div className="tooltip-header">
            {t('statusLegend.title')}
          </div>
          <div className="tooltip-content">
            <div className="status-legend-list">
              {STATUS_LIFECYCLE.map((status) => (
                <div key={status} className="status-legend-item">
                  <div className={`status-legend-badge status-legend-badge-${status.toLowerCase().replace('_', '-')}`}>
                    {t(`status.${status}`)}
                  </div>
                  <div className="status-legend-description">
                    <p>{t(`statusLegend.${status}.line1`)}</p>
                    <p>{t(`statusLegend.${status}.line2`)}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default StatusLegendTooltip;
